// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LgtmImageContent_wrapper__lD0JJ"};